import {Col, Layout, Row, App} from 'antd';
import {CopyrightOutlined,} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
const { Footer } = Layout;

function WebFoot(props) {
    const {message} = App.useApp()
    const navi = useNavigate();
    //清除缓存
    const cleanStorage = () => {
        localStorage.removeItem('jtg-caiwu_yh_id');
        localStorage.removeItem('jtg-caiwu_yh_phone');
        localStorage.removeItem('jtg-caiwu_qy_id');
        localStorage.removeItem('jtg-caiwu_qy_name');
        localStorage.removeItem('jtg-caiwu_yh_name');
        localStorage.removeItem('jtg-caiwu_yh_juese');
        localStorage.removeItem('jtg-caiwu_yh_qx');
        localStorage.removeItem('jtg-caiwu_mainTagActive');
        localStorage.removeItem('jtg-caiwu_spdd_spgg_id');
        localStorage.removeItem('jtg-caiwu_spdd_spgg_name');
        localStorage.removeItem('jtg-caiwu_dd_dq_date');
        localStorage.removeItem('jtg-caiwu_expenseNum');
        localStorage.removeItem('jtg-caiwu_jtg-caiwu_ysyf_id');
        localStorage.removeItem('jtg-caiwu_jtg-caiwu_dsbzd_id');
        localStorage.removeItem('jtg-caiwu_mainTag');
        localStorage.removeItem('jtg-caiwu_DividendsNum');
        localStorage.removeItem('jtg-caiwu_profitNum');
        message.success('清除成功！');
    }    
    return (
        <Footer style={{textAlign:'center',padding:"50px 0",background:"#000000",color:"#fff",width:"100vw",}}>
            <Row>
                <Col span={4}></Col>
                <Col span={16}>
                    <Row>
                        <Col span={6} style={{display:'flex',alignContent:"center",justifyContent:"space-between",cursor:"pointer",flexDirection:"column"}} >
                            <div><a onClick={() => {navi('/WebPassword') }}>重置密码</a></div>
                            <div><a href='/download/谷歌浏览器 (1).exe'>下载谷歌浏览器</a></div>
                            <div><a onClick={cleanStorage}>清除浏览器缓存</a></div>
                        </Col>
                        <Col span={6} style={{display:'flex',alignContent:"center",justifyContent:"space-between",flexDirection:"column"}}>
                            
                            <div><a onClick={() => {navi('/WebPassword') }}>重置密码</a></div>
                            <div><a href='/download/谷歌浏览器 (1).exe'>下载谷歌浏览器</a></div>
                            <div><a onClick={cleanStorage}>清除浏览器缓存</a></div>
                        </Col>
                       
                        <Col span={6}>
                            <h3>联系客服</h3>
                            <div style={{ textAlign: "center" }}><img src='./img/service.png' width={130} alt='' />  </div>
                        </Col>
                         <Col span={6} style={{display:'flex',alignContent:"center",justifyContent:"space-between",flexDirection:"column"}}>
                            <h3>版权所有</h3>
                            <div><CopyrightOutlined /> 2002 - 现在 qidangjia.net copyRight</div>
                            <div style={{marginTop:'10px'}} ><a onClick={() => {window.open('https://www.bnsrj.net/')}}>湖北伯纳思网络科技有限公司</a></div>
                            <div style={{marginTop:'10px'}}>
                                <a target="_blank" onClick={() => {window.open('https://beian.miit.gov.cn/')}} style={{cursor:'pointer'}}>鄂ICP备18025660号-9</a>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col span={4}></Col>
            </Row>
            
        </Footer>
    )
}

export default WebFoot;